import * as React from 'react'
const SvgComponent = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={188}
    height={169}
    preserveAspectRatio="xMidYMid meet"
    shapeRendering="geometricPrecision"
    vectorEffect="non-scaling-stroke"
    fill="none"
    {...props}
  >
    <g opacity={0.15}>
      <mask
        id="a"
        width={69}
        height={39}
        x={58}
        y={130}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path fill="#fff" d="M126.424 130.071h-67.47v38.326h67.47v-38.326Z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill="#000"
          d="M80.437 131.002 59.38 144.17a.91.91 0 0 0 .05 1.573l40.534 22.142a4.19 4.19 0 0 0 4.12-.062l21.557-12.619a1.6 1.6 0 0 0-.031-2.781l-38.943-21.588a6.131 6.131 0 0 0-6.224.167"
        />
      </g>
    </g>
    <path
      fill="#fff"
      d="M64.03 141.604s25.733 15.05 36.576 20.632c.783.4 4.983 1.289 8.758-.87 2.701-1.548 7.525-3.947 10.066-5.847 3.349-2.51 3.7-7.482.623-10.325-.093-.086-.185-.173-.284-.253-4.737-4.071-10.862-8.036-10.862-8.036s-6.901-8.703-9.01-10.146c0 0-6.286-5.403-14.291-7.753-5.305-1.555-12.317.863-17.819 4.453-7.833 4.638-7.47 9.184-7.186 12.397a7.372 7.372 0 0 0 1.617 4.015c.48.598 1.103 1.24 1.831 1.733"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="M64.03 141.604s25.733 15.05 36.576 20.632c.783.4 4.983 1.289 8.758-.87 2.701-1.548 7.525-3.947 10.066-5.847 3.349-2.51 3.7-7.482.623-10.325-.093-.086-.185-.173-.284-.253-4.737-4.071-10.862-8.036-10.862-8.036s-6.901-8.703-9.01-10.146c0 0-6.286-5.403-14.291-7.753-5.305-1.555-12.317.863-17.819 4.453-7.833 4.638-7.47 9.184-7.186 12.397a7.372 7.372 0 0 0 1.617 4.015c.48.598 1.103 1.24 1.831 1.733h-.018Z"
    />
    <path
      fill="#fff"
      d="m65.622 131.73 25.25 14.543s-3.484-11.324-11.638-15.709c-9.942-5.348-13.18-.056-13.68.931a.179.179 0 0 0 .068.235Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="m65.622 131.73 25.25 14.543s-3.484-11.324-11.638-15.709c-9.942-5.348-13.18-.056-13.68.931a.179.179 0 0 0 .068.235ZM90.873 146.273c2.38-.061 12.891-4.206 17.874-9.424"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="M84.86 135.264c3.373-.654 11.212-5.008 15.271-8.29M83.675 118.58c-3.071.543-6.932 2.998-11.768 6.279-2.227 1.505-6.735 1.406-7.84 1.406"
    />
    <path
      fill="currentColor"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      className="gray-element"
      d="M89.19 159.09c1.165 2.097 3.33 3.121 4.828 2.288 1.5-.832 1.77-3.213.605-5.31-1.166-2.097-3.33-3.121-4.83-2.289-1.498.833-1.77 3.214-.604 5.311ZM64.05 145.034c1.171 2.097 3.336 3.114 4.835 2.276 1.499-.839 1.758-3.22.586-5.311-1.172-2.097-3.337-3.115-4.836-2.276-1.499.839-1.758 3.22-.586 5.311Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      strokeWidth={0.5}
      d="M121.891 148.13a6.817 6.817 0 0 1-2.677 4.57c-2.535 1.9-7.365 4.305-10.06 5.853-3.768 2.165-7.95 1.228-8.752.876-.37-.16-.857-.401-1.443-.709-1.08-.568-1.974-1.462-2.461-2.578a9.461 9.461 0 0 0-.37-.753c-1.678-3.016-4.78-4.484-6.939-3.287h-.006a1.732 1.732 0 0 1-1.746-.019 1340.702 1340.702 0 0 1-14.26-8.671c-.715-.438-1.233-1.123-1.53-1.912a9.195 9.195 0 0 0-.542-1.185c-1.678-3.016-4.78-4.484-6.939-3.287a3.4 3.4 0 0 0-.197.117.834.834 0 0 1-.9 0s-.031-.018-.044-.031c-.721-.493-1.332-1.122-1.807-1.714a7.442 7.442 0 0 1-.623-.907"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      fill="#fff"
      d="m171.794 77.163 14.661 8.345-13.267 6.871-4.768-8.499 3.374-6.717Z"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      fill="#fff"
      d="M172.109 77.36a1.9 1.9 0 0 0-1.98-.042l-40.128 23.135a3.956 3.956 0 0 0-1.98 3.423v22.543c0 .37.198.709.519.895l12.409 7.037a1.028 1.028 0 0 0 1.536-.894v-21.378c0-1.412.752-2.72 1.98-3.423l40.127-23.135c1.277-.734 2.874.185 2.874 1.659v20.304a1.05 1.05 0 0 1-1.566.913l-12.367-7.013a1.05 1.05 0 0 1-.53-.913v-8.27"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M172.109 77.36a1.9 1.9 0 0 0-1.98-.042l-40.128 23.135a3.956 3.956 0 0 0-1.98 3.423v22.543c0 .37.198.709.519.895l12.409 7.037a1.028 1.028 0 0 0 1.536-.894v-21.378c0-1.412.752-2.72 1.98-3.423l40.127-23.135c1.277-.734 2.874.185 2.874 1.659v20.304a1.05 1.05 0 0 1-1.566.913l-12.367-7.013a1.05 1.05 0 0 1-.53-.913v-8.27M186.473 85.515l-14.364-8.154"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      fill="#fff"
      d="M163.788 97.468v-8.845a.616.616 0 0 0-.308-.53l-13.495-7.76a.345.345 0 0 0-.29-.024l-.025.012a.295.295 0 0 0-.043.019l-1.567.765.975 1.085.426-.142v7.186"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M163.788 97.468v-8.845a.616.616 0 0 0-.308-.53l-13.495-7.76a.345.345 0 0 0-.29-.024l-.025.012a.295.295 0 0 0-.043.019l-1.567.765.975 1.085.426-.142v7.186"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      fill="#fff"
      d="M162.228 98.22v-8.844a.617.617 0 0 0-.308-.531l-13.496-7.759a.35.35 0 0 0-.524.302v8.592l14.328 8.234v.006Z"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M162.228 98.22v-8.844a.617.617 0 0 0-.308-.531l-13.496-7.759a.35.35 0 0 0-.524.302v8.592l14.328 8.234v.006Z"
    />
    <g opacity={0.15}>
      <mask
        id="b"
        width={17}
        height={13}
        x={128}
        y={100}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path fill="#fff" d="M144.175 100.459h-16.154v11.626h16.154v-11.626Z" />
      </mask>
      <g mask="url(#b)">
        <path
          shapeRendering="geometricPrecision"
          vectorEffect="non-scaling-stroke"
          fill="#000"
          d="m128.021 103.882 14.464 8.203s-.241-1.856 1.69-3.238c-4.231-2.578-14.174-8.388-14.174-8.388s-1.98.598-1.98 3.423Z"
        />
      </g>
    </g>
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      fill="#fff"
      d="M178.19 117.272c0 1.493-2.467 2.702-5.508 2.702-3.04 0-5.501-1.209-5.501-2.702 0-1.492 2.467-2.701 5.501-2.701 3.035 0 5.508 1.209 5.508 2.701Z"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M178.19 117.272c0 1.493-2.467 2.702-5.508 2.702-3.04 0-5.501-1.209-5.501-2.702 0-1.492 2.467-2.701 5.501-2.701 3.035 0 5.508 1.209 5.508 2.701Z"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      fill="#fff"
      d="M173.54 116.865c0 .229-.383.414-.858.414s-.857-.185-.857-.414v-9.338h1.708v9.338h.007Z"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M173.54 116.865c0 .229-.383.414-.858.414s-.857-.185-.857-.414v-9.338h1.708v9.338h.007Z"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      fill="#fff"
      d="M179.164 107.126c0 1.882-3.114 3.411-6.957 3.411-3.842 0-6.957-1.529-6.957-3.411 0-1.881 3.115-3.41 6.957-3.41 3.843 0 6.957 1.529 6.957 3.41Z"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M179.164 107.126c0 1.882-3.114 3.411-6.957 3.411-3.842 0-6.957-1.529-6.957-3.411 0-1.881 3.115-3.41 6.957-3.41 3.843 0 6.957 1.529 6.957 3.41Z"
    />
    <g opacity={0.1}>
      <mask
        id="c"
        width={13}
        height={7}
        x={166}
        y={103}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path fill="#fff" d="M178.714 103.537h-12.557v5.477h12.557v-5.477Z" />
      </mask>
      <g mask="url(#c)">
        <path
          shapeRendering="geometricPrecision"
          vectorEffect="non-scaling-stroke"
          fill="#000"
          d="M178.714 106.275c0 1.511-2.812 2.739-6.278 2.739-3.467 0-6.279-1.228-6.279-2.739s2.812-2.738 6.279-2.738c3.466 0 6.278 1.227 6.278 2.738Z"
        />
      </g>
    </g>
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      fill="#fff"
      d="M181.348 92.262v8.475s.197 6.642-7.734 6.642c0 0-5.57-.154-4.022-7.783 1.678-8.296 6.063-10.424 9.128-9.998 2.646.364 2.628 2.67 2.628 2.67"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M181.348 92.262v8.475s.197 6.642-7.734 6.642c0 0-5.57-.154-4.022-7.783 1.678-8.296 6.063-10.424 9.128-9.998 2.646.364 2.628 2.67 2.628 2.67v-.006Z"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      fill="#fff"
      d="M177.74 105.745v3.337c0 .709-3.491 1.307-3.491 1.307l.481-.16c.376-.247.604-.666.604-1.11v-3.09"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M177.74 105.745v3.337c0 .709-3.491 1.307-3.491 1.307l.481-.16c.376-.247.604-.666.604-1.11v-3.09"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      fill="#fff"
      d="M159.65 128.214c0 1.493-2.467 2.702-5.508 2.702s-5.502-1.209-5.502-2.702c0-1.493 2.467-2.701 5.502-2.701 3.034 0 5.508 1.208 5.508 2.701Z"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M159.65 128.214c0 1.493-2.467 2.702-5.508 2.702s-5.502-1.209-5.502-2.702c0-1.493 2.467-2.701 5.502-2.701 3.034 0 5.508 1.208 5.508 2.701Z"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      fill="#fff"
      d="M154.999 127.801c0 .228-.382.413-.857.413s-.857-.185-.857-.413v-9.338h1.708v9.338h.006Z"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M154.999 127.801c0 .228-.382.413-.857.413s-.857-.185-.857-.413v-9.338h1.708v9.338h.006Z"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      fill="#fff"
      d="M160.624 118.062c0 1.881-3.114 3.411-6.957 3.411s-6.957-1.53-6.957-3.411 3.114-3.411 6.957-3.411 6.957 1.53 6.957 3.411Z"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M160.624 118.062c0 1.881-3.114 3.411-6.957 3.411s-6.957-1.53-6.957-3.411 3.114-3.411 6.957-3.411 6.957 1.53 6.957 3.411Z"
    />
    <g opacity={0.1}>
      <mask
        id="d"
        width={14}
        height={6}
        x={147}
        y={114}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path fill="#fff" d="M160.174 114.472h-12.558v5.477h12.558v-5.477Z" />
      </mask>
      <g mask="url(#d)">
        <path
          shapeRendering="geometricPrecision"
          vectorEffect="non-scaling-stroke"
          fill="#000"
          d="M160.174 117.211c0 1.511-2.812 2.738-6.279 2.738-3.466 0-6.279-1.227-6.279-2.738s2.813-2.739 6.279-2.739c3.467 0 6.279 1.228 6.279 2.739Z"
        />
      </g>
    </g>
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      fill="#fff"
      d="M162.808 103.198v8.474s.197 6.643-7.735 6.643c0 0-5.569-.154-4.021-7.784 1.677-8.296 6.063-10.423 9.128-9.998 2.646.364 2.628 2.671 2.628 2.671"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M162.808 103.198v8.474s.197 6.643-7.735 6.643c0 0-5.569-.154-4.021-7.784 1.677-8.296 6.063-10.423 9.128-9.998 2.646.364 2.628 2.671 2.628 2.671v-.006Z"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      fill="#fff"
      d="M159.199 116.68v3.337c0 .709-3.491 1.308-3.491 1.308l.482-.161c.376-.246.604-.666.604-1.11v-3.09"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M159.199 116.68v3.337c0 .709-3.491 1.308-3.491 1.308l.482-.161c.376-.246.604-.666.604-1.11v-3.09"
    />
    <g opacity={0.15}>
      <mask
        id="e"
        width={2}
        height={11}
        x={162}
        y={88}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path fill="#fff" d="M163.782 88.432h-1.566v9.788h1.566v-9.788Z" />
      </mask>
      <g mask="url(#e)">
        <path
          shapeRendering="geometricPrecision"
          vectorEffect="non-scaling-stroke"
          fill="#000"
          d="M162.246 89.326s-.111 9.024.111 8.9c.222-.123 1.104-.629 1.326-.758.21-.118.025-9.036.025-9.036"
        />
      </g>
    </g>
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      fill="#fff"
      d="m37.485 126.721-9.474 5.385-.099 1.055 2.264 1.591 9.474-5.483.19-1.104-2.355-1.444Z"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m37.485 126.721-9.474 5.385-.099 1.055 2.264 1.591 9.474-5.483.19-1.104-2.355-1.444Z"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      fill="#fff"
      d="m10.988 112.196-9.474 5.385-.092 1.061 2.257 1.585 9.474-5.477.191-1.11-2.356-1.444Z"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m10.988 112.196-9.474 5.385-.092 1.061 2.257 1.585 9.474-5.477.191-1.11-2.356-1.444Z"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      fill="#fff"
      d="m34.697 105.369-.099 24.911-.913.574-.863-.29v-25.195"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m34.697 105.369-.099 24.911-.913.574-.863-.29v-25.195"
    />
    <path fill="#fff" d="m8.872 90.418-.092 24.807-.913.579-.87-.289V90.319" />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m8.872 90.418-.092 24.807-.913.579-.87-.289V90.319"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      fill="#fff"
      d="m.626 67.314 2.208-1.357 40.004 23.129.24 27.452-2.88.784L.535 94.285l.092-26.971Z"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m.626 67.314 2.208-1.357 40.004 23.129.24 27.452-2.88.784L.535 94.285l.092-26.971Z"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      fill="#fff"
      d="M40.223 90.467 1.921 68.82v24.405l38.45 21.902-.148-24.659Z"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M40.223 90.467 1.921 68.82v24.405l38.45 21.902-.148-24.659ZM8.632 107.632l24.042 14.038M9.02 106.331l23.604 13.655"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={0.5}
      d="m35.08 75.313 31.726-18.386M142.559 77.984l-32.615-18.596M89.51 104.234l.388-34.947"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      fill="#fff"
      d="M94.95 10.323 78.729.893a2.123 2.123 0 0 0-2.196.03L74.01 2.38l.703.555.827-.512c-.019.105-.025.21-.025.321v44.248c0 1.27.685 2.455 1.789 3.09l15.567 8.986-1.295.605 1.542 1.104 2.436-1.413a2.247 2.247 0 0 0 1.19-1.998v-43.92c0-1.284-.69-2.48-1.794-3.122Z"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.339}
      d="M94.95 10.323 78.729.893a2.123 2.123 0 0 0-2.196.03L74.01 2.38l.703.555.827-.512c-.019.105-.025.21-.025.321v44.248c0 1.27.685 2.455 1.789 3.09l15.567 8.986-1.295.605 1.542 1.104 2.436-1.413a2.247 2.247 0 0 0 1.19-1.998v-43.92c0-1.284-.69-2.48-1.794-3.122Z"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      fill="#fff"
      d="M92.063 61.022a2.24 2.24 0 0 1-1.135-.308l-16.03-9.252a3.577 3.577 0 0 1-1.788-3.096V4.118a2.141 2.141 0 0 1 3.213-1.85l16.221 9.43a3.618 3.618 0 0 1 1.795 3.122v43.914c0 .63-.246 1.209-.697 1.64a2.261 2.261 0 0 1-1.579.636v.012Z"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.339}
      d="M92.063 61.022a2.24 2.24 0 0 1-1.135-.308l-16.03-9.252a3.577 3.577 0 0 1-1.788-3.096V4.118a2.141 2.141 0 0 1 3.213-1.85l16.221 9.43a3.618 3.618 0 0 1 1.795 3.122v43.914c0 .63-.246 1.209-.697 1.64a2.261 2.261 0 0 1-1.579.636v.012Z"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      fill="#fff"
      d="m92.07 12.531-2.659-1.548a1.615 1.615 0 0 1-2.085.414l-6.852-3.93a1.681 1.681 0 0 1-.839-1.27l-.11-.956-3.677-2.14a1.186 1.186 0 0 0-1.782 1.024v44.247c0 .938.5 1.801 1.307 2.27l16.03 9.258c.882.512 1.986-.13 1.986-1.147V14.826c0-.95-.505-1.82-1.32-2.3"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.339}
      d="m92.07 12.531-2.659-1.548a1.615 1.615 0 0 1-2.085.414l-6.852-3.93a1.681 1.681 0 0 1-.839-1.27l-.11-.956-3.677-2.14a1.186 1.186 0 0 0-1.782 1.024v44.247c0 .938.5 1.801 1.307 2.27l16.03 9.258c.882.512 1.986-.13 1.986-1.147V14.826c0-.95-.505-1.82-1.32-2.3v.005Z"
    />
    <path
      fill="#fff"
      d="m79.524 5.235.111.956c.062.53.37 1.005.833 1.27l6.852 3.935a1.616 1.616 0 0 0 2.085-.413"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.339}
      d="m79.524 5.235.111.956c.062.53.37 1.005.833 1.27l6.852 3.935a1.616 1.616 0 0 0 2.085-.413"
    />
    <path
      fill="#fff"
      d="M85.205 8.837a.17.17 0 0 1-.253.148L81.59 7.048a.18.18 0 0 1-.086-.148c0-.13.142-.21.253-.142l3.361 1.937a.18.18 0 0 1 .087.148"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.339}
      d="M85.205 8.837a.17.17 0 0 1-.253.148L81.59 7.048a.18.18 0 0 1-.086-.148c0-.13.142-.21.253-.142l3.361 1.937a.18.18 0 0 1 .087.148v-.006Z"
    />
    <path
      fill="#fff"
      d="m86.537 9.885-.87-.505a.171.171 0 0 1-.08-.142c0-.13.142-.21.253-.142l.87.506a.166.166 0 1 1-.173.284Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.339}
      d="m86.537 9.885-.87-.505a.171.171 0 0 1-.08-.142c0-.13.142-.21.253-.142l.87.506a.166.166 0 1 1-.173.284Z"
    />
    <g opacity={0.15}>
      <mask
        id="f"
        width={4}
        height={5}
        x={93}
        y={10}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path fill="#fff" d="M96.77 10.662h-3.738v4.016h3.737v-4.016Z" />
      </mask>
      <g mask="url(#f)">
        <path
          fill="#000"
          d="m93.032 12.063 2.424-1.4.19.221c.463.543.883 1.049 1.006 1.863l.123.432-2.423 1.505s-.124-1.215-.512-1.684"
        />
      </g>
    </g>
    <g opacity={0.8}>
      <mask
        id="g"
        width={20}
        height={59}
        x={74}
        y={2}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path fill="#fff" d="M93.383 2.934H74.078v57.138h19.305V2.934Z" />
      </mask>
      <g mask="url(#g)" opacity={0.15}>
        <mask
          id="h"
          width={20}
          height={59}
          x={74}
          y={2}
          maskUnits="userSpaceOnUse"
          style={{
            maskType: 'luminance',
          }}
        >
          <path fill="#fff" d="M93.383 2.934H74.078v57.138h19.305V2.934Z" />
        </mask>
        <g mask="url(#h)">
          <path
            fill="#000"
            d="M76.718 49.563a2.624 2.624 0 0 1-1.308-2.27V3.045c0-.037 0-.068.007-.098a1.186 1.186 0 0 0-1.333 1.178v44.247c0 .938.5 1.801 1.308 2.27l16.03 9.258c.808.469 1.8-.031 1.961-.9-.21 0-.425-.056-.635-.18l-16.03-9.251v-.006Z"
          />
        </g>
      </g>
    </g>
    <path
      fill="#fff"
      d="M95.418 22.647v2.781c0 .13.13.21.247.154a.169.169 0 0 0 .099-.154v-2.781a.172.172 0 0 0-.26-.148.166.166 0 0 0-.086.148Z"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.339}
      d="M95.418 22.647v2.781c0 .13.13.21.247.154a.169.169 0 0 0 .099-.154v-2.781a.172.172 0 0 0-.26-.148.166.166 0 0 0-.086.148Z"
    />
    <path
      fill="#fff"
      d="M95.418 36.061v2.782c0 .13.13.21.247.154a.169.169 0 0 0 .099-.154v-2.782a.172.172 0 0 0-.26-.148.166.166 0 0 0-.086.148Z"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.339}
      d="M95.418 36.061v2.782c0 .13.13.21.247.154a.169.169 0 0 0 .099-.154v-2.782a.172.172 0 0 0-.26-.148.166.166 0 0 0-.086.148Z"
    />
    <path
      fill="currentColor"
      className="gray-element"
      d="M75.46 9.108v6.26c0 .26.142.5.364.63l15.252 9.091a.726.726 0 0 0 1.086-.63v-5.655c0-.592-.315-1.147-.833-1.443L76.545 8.479a.724.724 0 0 0-1.085.63Z"
    />
    <path
      fill="currentColor"
      className="gray-element"
      d="M79.185 14.345a.395.395 0 0 0 .117-.05c.376-.216.389-.912.019-1.554-.37-.641-.975-.98-1.357-.758-.376.215-.389.912-.019 1.554.031.055.062.105.099.154-1.055-.228-1.172 1.147-1.172 1.147l3.374 1.974s.13-1.394-1.067-2.467"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M79.185 14.345a.395.395 0 0 0 .117-.05c.376-.216.389-.912.019-1.554-.37-.641-.975-.98-1.357-.758-.376.215-.389.912-.019 1.554.031.055.062.105.099.154-1.055-.228-1.172 1.147-1.172 1.147l3.374 1.974s.13-1.394-1.067-2.467h.006Z"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      fill="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M79.185 14.345a.395.395 0 0 0 .117-.05c.376-.216.389-.912.019-1.554-.37-.641-.975-.98-1.357-.758-.376.215-.389.912-.019 1.554.031.055.062.105.099.154-1.055-.228-1.172 1.147-1.172 1.147l3.374 1.974s.13-1.394-1.067-2.467h.006Z"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      fill="currentColor"
      className="gray-element"
      d="M75.367 19.365v6.26c0 .26.142.5.364.63l15.253 9.09a.726.726 0 0 0 1.085-.628V29.06c0-.592-.314-1.147-.832-1.443l-14.784-8.882a.723.723 0 0 0-1.086.63ZM75.46 29.992v6.26c0 .26.142.5.364.63l15.252 9.091a.726.726 0 0 0 1.086-.63v-5.655c0-.592-.315-1.147-.833-1.443l-14.784-8.882a.724.724 0 0 0-1.085.63Z"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      fill="currentColor"
      className="gray-element"
      d="M79.185 35.229a.395.395 0 0 0 .117-.05c.376-.215.389-.912.019-1.554-.37-.641-.975-.98-1.357-.758-.376.215-.389.912-.019 1.554.031.055.062.105.099.154-1.055-.228-1.172 1.147-1.172 1.147l3.374 1.974s.13-1.394-1.067-2.467"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M79.185 35.229a.395.395 0 0 0 .117-.05c.376-.215.389-.912.019-1.554-.37-.641-.975-.98-1.357-.758-.376.215-.389.912-.019 1.554.031.055.062.105.099.154-1.055-.228-1.172 1.147-1.172 1.147l3.374 1.974s.13-1.394-1.067-2.467h.006Z"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={0.352}
      d="M75.46 40.428v6.26c0 .26.142.5.364.63l15.252 9.09a.726.726 0 0 0 1.086-.628v-5.656c0-.592-.315-1.147-.833-1.443l-14.784-8.882a.724.724 0 0 0-1.085.63Z"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      fill="currentColor"
      className="gray-element"
      d="m80.671 45.159-.758-1.043s-.043-.03-.062-.018l-1.283.469-1.307-1.795s-.019-.012-.031-.012l-.771.283s-.025.031-.013.043l1.296 1.783-1.252.462a.054.054 0 0 0-.025.087l.759 1.042s.043.031.061.019l1.277-.47 1.308 1.796s.018.012.03.012l.771-.284s.025-.03.013-.043l-1.296-1.782 1.252-.463a.054.054 0 0 0 .025-.086"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      fill="#fff"
      d="m78.457 26.224-1.542-2.652s-.006-.068.025-.087l.573-.326s.068-.007.087.024l.913 1.56 2.017-1.214c.03-.019.074-.007.092.024l.61 1.049c.02.03.007.08-.024.098l-2.695 1.536s-.043 0-.05-.012M78.457 36.79l-1.542-2.653s-.006-.068.025-.086l.573-.327s.068-.006.087.025l.913 1.56 2.017-1.215a.07.07 0 0 1 .092.025l.61 1.048c.02.031.007.08-.024.099l-2.695 1.536s-.043 0-.05-.013M78.457 16.127l-1.542-2.652s-.006-.068.025-.086l.573-.327s.068-.006.087.024l.913 1.56 2.017-1.214c.03-.019.074-.006.092.024l.61 1.049c.02.03.007.08-.024.099l-2.695 1.536s-.043 0-.05-.013"
    />
  </svg>
)
export default SvgComponent
